import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import IconCar from '@svg/usps/icon-car.svg';
import IconCareer from '@svg/usps/icon-career.svg';
import IconCv from '@svg/usps/icon-cv.svg';
import IconWallet from '@svg/usps/icon-wallet.svg';
import IconUnknown from '@svg/usps/icon-unknown.svg';
import styles from './Usps.module.scss';

const Usps = ({ company, usps }) => {
  const { t } = useTranslation('vacancy');

  const getIcon = icon => {
    switch (icon) {
      case 'ICON_1':
        return <IconCar />;
      case 'ICON_2':
        return <IconCareer />;
      case 'ICON_3':
        return <IconCv />;
      case 'ICON_4':
        return <IconWallet />;
      default:
        return <IconUnknown />;
    }
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{t('uspsTitle', { company })}</h2>
      <ul className={styles.list}>
        {usps.map(({ icon, text }, i) => (
          <li key={i} className={styles.item}>
            <div className={styles.icon}>{getIcon(icon)}</div>
            <div className={styles.text}>{text}</div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Usps;

Usps.propTypes = {
  company: PropTypes.string.isRequired,
  usps: PropTypes.array.isRequired,
};
